// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollGroupDto
 */
export interface IPayrollGroupDto {
    /**
     * 
     * @type {number}
     * @memberof IPayrollGroupDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollGroupDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollGroupDto
     */
    code?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollGroupDto
     */
    created_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IPayrollGroupDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollGroupDto
     */
    organization_path?: string;
}

/**
 * Check if a given object implements the IPayrollGroupDto interface.
 */
export function instanceOfIPayrollGroupDto(value: object): value is IPayrollGroupDto {
    return true;
}

export function IPayrollGroupDtoFromJSON(json: any): IPayrollGroupDto {
    return IPayrollGroupDtoFromJSONTyped(json, false);
}

export function IPayrollGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
    };
}

export function IPayrollGroupDtoToJSON(json: any): IPayrollGroupDto {
    return IPayrollGroupDtoToJSONTyped(json, false);
}

export function IPayrollGroupDtoToJSONTyped(value?: IPayrollGroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
    };
}

